import "./utils/ioSetup";
import React, {
  JSXElementConstructor,
  ReactElement,
  useMemo,
  useEffect,
} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RegisterPage } from "./routes/Register";
import { LoginPage } from "./routes/Login";
import { Background } from "./components/Background";
import { ChooseRolePage } from "./routes/ChooseRole/index";
import { ResetPasswordPage } from "./routes/ResetPassword/index";
import { AuthorizePage } from "./routes/Authorize/index";
import { RegisterCompletePage } from "./routes/RegisterComplete/index";
import { UserPage } from "./routes/User/index";
import { LaunchpadPage } from "./routes/Launchpad/index";
import { ResetMFA } from "./routes/ResetMFA";
import { Error404Page } from "./routes/Error/404";
import { ProblemPage } from "./routes/Problem";
import { Guidance } from "./components/Guidance";
import { SubAccountPage } from "./routes/SubAccount";
import { AgreementPage } from "./routes/Agreement";
import { FeedbackSuccessPage } from "./routes/FeedbackSuccess";
import { BindFace } from "./routes/BindFaceMFA";
import { BindTotpMFA } from "./routes/BindTotpMFA";
import { RouterGuard } from "./components/RouterGuard";
import { ErrorPermissionPage } from "./routes/Error/permission";
import { DownloadGA } from "./routes/DownloadGA";
import { getInitLang } from "./locales";
import { ChangePassword } from "./components/ChangePassword";

export const App = () => {
  const config = window.__config__;
  const registerDisabled =
    config?.ssoPageComponentDisplay?.autoRegisterThenLoginHintInfo;
  useEffect(() => {
    // 先看一下有没有
    if (
      window.__userPortalConfig__?.defaultLang &&
      window.__userPortalConfig__?.defaultLang !== "browser"
    ) {
      // console.log("新的");
      document.documentElement.lang = window.__userPortalConfig__.defaultLang;
    } else {
      // console.log("原来的");
      document.documentElement.lang = getInitLang();
    }
    // console.log(getInitLang());
    // document.documentElement.lang = getInitLang();
  });

  const routerConfig = useMemo<
    {
      path: string;
      element: ReactElement<any, string | JSXElementConstructor<any>>;
      unRender?: boolean;
    }[]
  >(
    () => [
      {
        path: "/",
        element: <LoginPage />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/sub-account",
        element: <SubAccountPage />,
      },
      {
        path: "/register",
        element: <RegisterPage />,
        unRender: registerDisabled,
      },
      {
        path: "/register-complete",
        element: <RegisterCompletePage />,
      },
      {
        path: "/choose-role",
        element: <ChooseRolePage />,
      },
      {
        path: "/download-ga",
        element: <DownloadGA />,
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
      },
      {
        path: "/authz",
        element: <AuthorizePage />,
      },
      {
        path: "/u",
        element: <UserPage />,
      },
      {
        path: "/login/profile",
        element: <UserPage />,
      },
      {
        path: "/launchpad",
        element: <LaunchpadPage />,
      },
      {
        path: "/reset-mfa",
        element: <ResetMFA />,
      },
      {
        path: "/bind-face",
        element: <BindFace />,
      },
      {
        path: "/bind-totp",
        element: <BindTotpMFA />,
      },
      {
        path: "/initial-password",
        element: <ChangePassword type="inital" />,
      },
      {
        path: "/reset-change-password",
        element: <ChangePassword type="reset" />,
      },
      {
        path: "/error/404",
        element: <Error404Page />,
      },
      {
        path: "/error/no-permission",
        element: <ErrorPermissionPage />,
      },
      {
        path: "/feedback",
        element: <ProblemPage />,
      },
      {
        path: "/feedback-success",
        element: <FeedbackSuccessPage />,
      },
      {
        path: "/agreement",
        element: <AgreementPage />,
      },
    ],
    [registerDisabled]
  );

  return (
    <Background>
      <Guidance />
      <BrowserRouter>
        <Routes>
          {routerConfig.map((item) =>
            item.unRender ? null : (
              <Route
                key={item.path}
                path={item.path}
                element={
                  <RouterGuard key={item.path}>{item.element}</RouterGuard>
                }
              />
            )
          )}
        </Routes>
      </BrowserRouter>
    </Background>
  );
};
